import { useMutation, useQueryClient } from "@tanstack/react-query";
import axiosInstance from "../../../api";
import { useOktaAuth } from "@okta/okta-react";
import FileActions from "../../FileActions";
import { useHistory } from "react-router-dom";
import toastMessages from "../../helpers/toastMessage";
interface PhysicianApprovalProps {
 orderIds: number[];
 username: string;
 password: string;
//  currentDate: string;
 image?: File;
 file?: {
  fileName: string;
  base64url: string;
 };
 eSignatureId?: string;
 token?: string;
}

function requestPayload(data: PhysicianApprovalProps): Promise<{
 orderIds: number[];
 username: string;
 password: string;
//  currentDate: string;
 eSignatureId?: string;
 blobUrl?: string;
}> {
 return new Promise(async (resolve, reject) => {
  if (data.file) {
   try {
    const fileActions = new FileActions();
    let file: any = await fileActions.convertBase64ToImage(
     data.file?.base64url ?? "",
     data.file?.fileName ?? ""
    );
    const filePath = await fileActions.uploadToAzure({
     type: "images/esignatures",
     file,
     token: data.token ?? "",
    });

    return resolve({
     orderIds: data.orderIds,
     username: data.username,
     password: data.password,
    //  currentDate: data.currentDate,
     eSignatureId: data.eSignatureId,
     blobUrl: filePath,
    });
   } catch (error: any) {
    return reject(new Error(error.message));
   }
  }

  /**
   * Upload Signature currently disabled
   */
  // if (data.image) {
  //   try {
  //     const fileActions = new FileActions();
  //     const filePath = await fileActions.uploadToAzure({
  //       type: "images/esignatures",
  //       file: data.image,
  //       token: data.token ?? "",
  //     });

  //     return resolve({
  //       orderIds: data.orderIds,
  //       username: data.username,
  //       password: data.password,
  //       currentDate: data.currentDate,
  //       eSignatureId: data.eSignatureId,
  //       blobUrl: filePath,
  //     });
  //   } catch (error: any) {
  //     return reject(new Error(error.message));
  //   }
  // }
  return resolve({
   orderIds: data.orderIds,
   username: data.username,
//    currentDate: data.currentDate,
   password: data.password,
   eSignatureId: data.eSignatureId,
   blobUrl: "",
  });
 });
}

async function sendForApproval(data: PhysicianApprovalProps) {
 return axiosInstance.put(
  `v1/orders/new-flow/approval`,
  await requestPayload(data),
  {
   headers: {
    Authorization: `Bearer ${data.token}`,
   },
  }
 );
}

function useSendForApproval() {
 const { authState } = useOktaAuth();
 const queryClient = useQueryClient();
 const history = useHistory();

 return useMutation({
  mutationKey: ["approvePhysician"],
  mutationFn: (data: PhysicianApprovalProps) =>
   sendForApproval({
    ...data,
    token: authState?.accessToken?.accessToken ?? "",
   }),
  onError: (error: any) => {
   const message =
     error?.response?.data?.message ??
     error?.message ??
     "Failed submitting for authorization";
   toastMessages.error(message);
  },
  onSuccess: (response) => {
   toastMessages.success("Order Approved");
   queryClient.refetchQueries({ queryKey: ["dashboardStatus"] });
   queryClient.refetchQueries({ queryKey: ["physicianSignature"] });
   queryClient.invalidateQueries({ queryKey: ["testOrdersList"] });
   // Navigation handled by component for approvals flow
   // history.replace("/access/test-orders");
  },
 });
}

export default useSendForApproval;
